import { useEffect } from "react"
import * as Sentry from "@sentry/react"

// eslint-disable-next-line sonarjs/no-globals-shadowing
export default function Error({
  error,
  resetError,
}: {
  error: Error
  resetError: () => void
}) {
  useEffect(() => {
    console.error(error)

    Sentry.captureException(error)
  }, [error])

  const getErrorDetails = (error: Error & { digest?: string }) => {
    return {
      digest: error.digest,
      message: error.message,
    }
  }

  return (
    <div className="w-100vw flex flex-col text-center">
      <h2 className="mt-20">Error occurred, report to admins</h2>
      <h2>Возникла ошибка, сообщите администраторам</h2>
      <p className="mt-5">{JSON.stringify(getErrorDetails(error), null, 2)}</p>
      <button
        onClick={() => resetError()}
        className="bg-button mx-auto mt-5 w-[30%] rounded-xl p-3 text-[#ffffff]"
      >
        Try again
      </button>
    </div>
  )
}
